<template>
<el-dialog :title="viewFlag === 'view' ? '查看' : !dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" width="70%" :visible.sync="viewData.visible">

    <!-- 生产量纲 车型 汇率 零件名称 零件号 零件-单车用量 零件-装配比例 零件-供货比例 模具费支付方式 开发费支付方式 开标时间 报价截止时间 工厂编号 备注特殊要求-->
    <!-- <el-steps :active="active" finish-status="success" process-status="error">
        <el-step title="任务开始"></el-step>
        <el-step title="询价"></el-step>
        <el-step title="报价"></el-step>
        <el-step title="合同"></el-step>
        <el-step title="协议"></el-step>
        <el-step title="订单"></el-step>
        <el-step title="交货"></el-step>
        <el-step title="任务结束"></el-step>
    </el-steps> -->
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="org-dialog-form">
        <div class="des_box mb15">
            <el-descriptions class="margin-top" :column="3" size="small" border>
                <el-descriptions-item label="定点申请" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="technicalName" style="margin-bottom: 0">
                        {{technicalName}}
                        <!-- &nbsp;&nbsp;<el-button v-if="dataForm.taskStatus === TASK_STATUS.WAITING && viewFlag !== 'view'" size="small" @click="selectTech()">
                            选择
                        </el-button> -->
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="定点申请编码" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="technicalCode" style="margin-bottom: 0" size="small">
                        <el-button size="small" @click="techView()" type="text">{{ dataForm.technicalCode }}</el-button>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="定点申请类型" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="technicalType" style="margin-bottom: 0" size="small">
                        <span>{{ getTechnicalValue(technicalType) }}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="任务编码" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="taskCode" style="margin-bottom: 0" size="small">
                        <span>{{ dataForm.taskCode }}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="询价单编码" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="rfqCode" style="margin-bottom: 0" size="small">
                        <span>{{ dataForm.rfqCode }}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="项目名称" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="projectName" style="margin-bottom: 0" size="small">
                        <span>{{ projectName }}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="采购负责人" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="supplyResponsor" style="margin-bottom: 0">
                        {{dataForm.supplyResponsor}}
                        <!-- <el-button v-if="(dataForm.taskStatus === TASK_STATUS.WAITING || dataForm.taskStatus === TASK_STATUS.REJECT) && viewFlag !== 'view'" size="small" @click="selectResponsor(0)">
                            选择
                        </el-button> -->
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="项目总监" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="techResponsor" style="margin-bottom: 0">
                        {{dataForm.techResponsor}}
                        <!-- <el-button v-if="(dataForm.taskStatus === TASK_STATUS.WAITING || dataForm.taskStatus === TASK_STATUS.REJECT) && viewFlag !== 'view'" size="small" @click="selectResponsor(1)">选择</el-button> -->
                    </el-form-item>
                </el-descriptions-item>

                <el-descriptions-item label="质量负责人" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="qualityResponsor" style="margin-bottom: 0">
                        {{dataForm.qualityResponsor}}
                        <!-- <el-button v-if="(dataForm.taskStatus === TASK_STATUS.WAITING || dataForm.taskStatus === TASK_STATUS.REJECT) && viewFlag !== 'view'" size="small" @click="selectResponsor(2)">选择</el-button> -->
                    </el-form-item>
                </el-descriptions-item>
                <!-- <el-descriptions-item label="采购工程师" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="supplyEngineer" style="margin-bottom: 0">
                        {{dataForm.supplyEngineer}}&nbsp;&nbsp;
                        <el-button v-if="(dataForm.taskStatus === TASK_STATUS.WAITING || dataForm.taskStatus === TASK_STATUS.REJECT) && viewFlag !== 'view'" size="small" @click="selectResponsor(3)">选择</el-button>
                    </el-form-item>
                </el-descriptions-item> -->

                <el-descriptions-item :span="3" label="任务描述" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="remark" style="margin-bottom: 0" size="small">
                        <el-input type="textarea" :rows="2" v-if="(dataForm.taskStatus === TASK_STATUS.WAITING || dataForm.taskStatus === TASK_STATUS.REJECT) && viewFlag !== 'view'" v-model="dataForm.remark" placeholder="任务描述" clearable></el-input>
                        <span v-else>{{ dataForm.remark }}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item :span="3" label="退回理由" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="rejectReason" style="margin-bottom: 0" size="small">
                        <span>{{ dataForm.rejectReason }}</span>
                    </el-form-item>
                </el-descriptions-item>
            </el-descriptions>
        </div>
    </el-form>
    <el-table :data="this.partList" :row-style="getRowStyle" @selection-change="selectionChangeHandle" size="small" border style="width: 100%" :header-cell-style="{ background: '#f5f5f5' }" class="mb15">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column type="index" width="50" label="序号">
            <template slot-scope="scope">
                {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
            </template>
        </el-table-column>
        <el-table-column prop="partCode" header-align="center" align="left" label="零件编号">
        </el-table-column>
        <el-table-column prop="partName" header-align="center" align="left" label="零件名称">
        </el-table-column>
        <el-table-column prop="cancelFlag" width="160" header-align="center" align="left" label="取消标识">
          <template slot-scope="scope">
            <span>{{ scope.row.cancelFlag === 1 ? '是' : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="oneCarCount" header-align="center" align="right" label="单车用量" width="80">
        </el-table-column>
        <el-table-column prop="targetPrice" header-align="center" align="right" label="目标价格" width="80">
        </el-table-column>
        <el-table-column prop="supplyStatus" header-align="center" align="center" label="建议货源" width="80">
            <template slot-scope="scope">
                <span>{{supplyStatusFormat(scope.row.supplyStatus)}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="supplyEngineerId" header-align="center" align="left" width="120" label="采购工程师">
            <template slot-scope="scope">
                 {{scope.row.supplyEngineer}}
            </template>
        </el-table-column>
        <el-table-column prop="targetInvestment" header-align="center" width="90" align="center" label="目标工装费">
        </el-table-column>
        <el-table-column prop="targetDevelopment" header-align="center" width="90" align="center" label="目标开发费">
        </el-table-column>
        <el-table-column prop="targetTestfee" header-align="center" width="90" align="center" label="目标试验费">
        </el-table-column>
      <el-table-column prop="positionName" header-align="center" align="center" label="采购工程师岗位" width="200">
        <template slot-scope="scope">
          <template v-if="viewFlag === 'view' || (dataForm.taskStatus !== '0' && dataForm.taskStatus !== '5')">
            <!-- 不可编辑状态，显示岗位名称 -->
            <span>{{ scope.row.positionName || '' }}</span>
          </template>
          <template v-else>
            <!-- 可编辑状态，显示下拉选择框 -->
            <el-select
                v-model="scope.row.selectedPositionId"
                placeholder="请选择岗位"
                size="mini"
                clearable
                :disabled="viewFlag === 'view' || (dataForm.taskStatus !== '0' && dataForm.taskStatus !== '5')"
                @change="handlePositionChange(scope.row, $event)"
            >
              <el-option
                  v-for="position in scope.row.positionList || []"
                  :key="position.positionId"
                  :label="position.positionName"
                  :value="position.positionId">
              </el-option>
            </el-select>
            <div v-if="!scope.row.selectedPositionId && viewFlag !== 'view' && (dataForm.taskStatus === '0' || dataForm.taskStatus === '5')"
                 class="error-tip" style="color: #f56c6c; font-size: 12px;">
              岗位为必选项
            </div>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50, 100, 200]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
    <span v-if="viewFlag === 'view'" slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewData.visible = false">
            取消
        </el-button>
    </span>

    <span v-else slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewData.visible = false">
            取消
        </el-button>
        <template v-if="(dataForm.taskStatus === TASK_STATUS.WAITING || dataForm.taskStatus === TASK_STATUS.RELEASED || dataForm.taskStatus === TASK_STATUS.REJECT) && viewFlag !== 'view'">
            <el-button size="small" type="primary" @click="selectResponsorPop()" :disabled="(dataForm.taskStatus === '0' || dataForm.taskStatus === '5') ? false : true">
                分配
            </el-button>
            <el-button size="small" type="primary" plain @click="dataSave()" :loading="loading" :disabled="(dataForm.taskStatus === '0' || dataForm.taskStatus === '5') ? false : true">
                保存
            </el-button>
            
            <el-button size="small" type="success" plain @click="dataConfirm()" :loading="loading" :disabled="(dataForm.taskStatus === '6' || dataForm.taskStatus === '5') ? false : true">
                发布
            </el-button>
        </template>
        <el-button type="danger" size="small" v-if="this.dataForm.taskStatus === '0' && dataForm.taskCode == null && this.plmTechCount > 0" @click="deleteHandle(dataForm.id, dataForm.taskStatus)" plain :loading="loading">
                <!-- <el-button size="small" type="danger" plain @click="rejectView()" :loading="loading"> -->
                <!-- v-if="userInfo.typeId !== USER_TYPE.SUPPLIER && dataForm.taskStatus === CONST_TASK_STATUS.DISTRIBUTED" -->
                废弃
        </el-button>
        <!--<el-button :disabled="dataForm.taskCode !== null" type="danger" size="small" @click="backHandle(dataForm.id)" plain :loading="loading">-->
                <!-- <el-button size="small" type="danger" plain @click="rejectView()" :loading="loading"> -->
                <!-- v-if="userInfo.typeId !== USER_TYPE.SUPPLIER && dataForm.taskStatus === CONST_TASK_STATUS.DISTRIBUTED" -->
                <!-- 退回定点申请 -->
        <!--</el-button>-->
    </span>
    <common-user-dialog ref="commonUserDialog"></common-user-dialog>
    <!-- 查看定点申请详情 -->
    <task-get-tech ref="addOrUpdateTech"></task-get-tech>
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate"></add-or-update>
    <task-reject-reason ref="taskRejectReason"></task-reject-reason>
</el-dialog>
</template>

<script>
import {
    addPurchaseTask,
    editPurchaseTask,
    editPurchaseTaskCon,
    deletePurchaseTaskFei,
    backPurchaseTaskFei,
    getPurchaseTaskById,
} from "@/controller/purchaseTask";
import {
    getTaskApparmentList,
    deleteTaskApparmentByIds,
} from "@/controller/tech";
import {
    getPlmTechnicalCountByPT
} from "@/controller/plmTech";
import moment from "moment";
import {
    DIALOG_CLOSED_TYPE,
    TASK_STATUS,
    USER_TYPE,
    SUPPLY_STATUS,
    TECHNICAL_NOTIFICATION_TYPE,
    getLabelByValue,
    getTechnicalValue
} from "@/utils/const";
import {
    mapping
} from "@/utils";
import CommonUserDialog from "@/views/common/common-user-dialog";
import AddOrUpdate from "../requirement/tech-add-or-update";
import TaskRejectReason from "@/views/common/reject-reason";
import TaskGetTech from "./task-tech-list";
import {
    setLoading
} from "@/utils/index";
// require('@/mock/mockTask');
export default {
    data() {
        let checkResponsor = (rule, value, callback) => {
            console.log(rule, value, this.dataForm.settingTaskStatus)
            if (!value && this.dataForm.settingTaskStatus != TASK_STATUS.REJECT) {
                return callback(new Error(rule.message)),
                    this.loading = false
            } else {
                callback();
            }
        };
        return {
            FILE_BIZ_TYPE: 12,
            active: 3,
            viewFlag: "",
            loading: false,
            dataRule: {
                supplyResponsor: [{
                    message: "请选择采购负责人",
                    trigger: "blur",
                    validator: checkResponsor
                }],
                techResponsor: [{
                    message: "请选择项目总监",
                    trigger: "blur",
                    validator: checkResponsor
                }],
                qualityResponsor: [{
                    message: "请填写质量负责人",
                    trigger: "blur",
                    validator: checkResponsor
                }],
                supplyEngineer: [{
                    message: "请填写采购工程师",
                    trigger: "blur",
                    validator: checkResponsor
                }],
            },
            viewData: {
                visible: false,
                width: "",
            },
            taskGetTechVisible: false,
            taskGetAppartVisible: false,
            addOrUpdateVisible: false,
            dataList: [],
            supplierList: [],
            userInfo: "",
            USER_TYPE: USER_TYPE,
            SUPPLY_STATUS: SUPPLY_STATUS,
            TASK_STATUS: TASK_STATUS,
            getLabelByValue: getLabelByValue,
            getTechnicalValue: getTechnicalValue,
            TECHNICAL_NOTIFICATION_TYPE: TECHNICAL_NOTIFICATION_TYPE,
            technicalName: '',
            technicalCode: '',
            technicalType: '',
            projectName: '',
            pageIndex: 1,
            pageSize: 20,
            totalPage: 0,
            dataListSelections: [],//多选的row
            // 任务表里字段
            dataForm: {
                id: 0,
                // ...this.dataForm,
                projectId: "",
                projectCode: "",
                projectName: "",
                taskCode: "",
                taskName: "",
                carType: "",
                projectManagerId: "",
                projectManagerName: "",
                taskType: "",
                taskStatus: "",
                createTaskTime: "",
                times: "",
                askPriceCode: "",
                feeCode: "",
                askPriceStatus: "",
                delayTimes: "",
                rfqCreateTime: "",
                rfqFinishTime: "",
                submitor: "",
                technicalId: "",
                technicalName: "", //数据库里没有
                technicalType: '',
                submitorId: "",
                technicalCode: "",
                supplyResponsorId: "",
                supplyResponsor: "",
                techResponsorId: "",
                techResponsor: "",
                qualityResponsorId: "",
                supplyEngineerId: "",
                qualityResponsor: "",
                supplyEngineer: "",
                remark: "",
                rfqCode: "",
                partList:"",
                rejectReason:'',
            },
            partList:[],
            plmTechCount: 0,
        };
    },
    components: {
        CommonUserDialog,
        TaskGetTech,
        TaskRejectReason,
        AddOrUpdate
    },
    mounted() {
        this.getTaskApparmentList();
    },
    methods: {
        getRowStyle({ row, rowIndex }) {
          if (row.cancelFlag === 1) {
            return { backgroundColor: '#f5f7fa' }; // 灰色背景
          }
          return {};
        },
        init(rec, viewFlag) {
            // this.dataForm = data ? data : this.dataForm
            this.userInfo = this.$store.state.user.userInfo;
            this.viewFlag = viewFlag;
            this.technicalName = rec && rec.technicalName || ''
            this.technicalCode = rec && rec.technicalCode || ''
            this.technicalType = rec && rec.technicalType || ''
            this.projectName = rec && rec.projectName || ''
            this.dataForm.id = rec && rec.id || 0
            this.viewData.visible = true;
            this.loading = false
            this.$nextTick(() => {
                //初始化上传附件
                // this.dataForm.tenantName = sessionStorage.getItem('tenantName')
                if (this.dataForm && this.dataForm.id) {
                    getPurchaseTaskById({}, this.dataForm.id).then((data) => {
                        if (data && data.code === "00") {
                            mapping(data.body, this.dataForm);
                        }
                        if(this.dataForm.taskCode == null || this.dataForm.taskCode == '') {
                            this.getPlmTechnicalCountByPT(this.technicalCode)
                        }
                    });
                    this.getTaskApparmentList();
                }
            });
            
        },
        dateFormat: function (row, column) {
            var date = row[column.property];
            if (date == undefined) {
                return "";
            }
            return moment(date).format("YYYY-MM-DD前");
        },
        dateFormatValue: function (value) {
            if (value == undefined) {
                return "";
            }
            return moment(value).format("YYYY-MM-DD前");
        },
        getTaskApparmentList() {
            console.log(this.dataForm.taskStatus === 5 ? false : true);
            getTaskApparmentList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                taskId: this.dataForm.id,
            }).then((data) => {
                if (data && data.code === "00") {
                    this.partList = data.body.records
                    this.totalPage = data.body.total
                    console.log(this.partList);
                }
            });
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getTaskApparmentList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getTaskApparmentList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
        },
        // 表单提交
      dataSave() {
        let params = {...this.dataForm};
        params.partList = this.partList;

        if (params.taskStatus !== TASK_STATUS.DISTRIBUTED) {
          params.settingTaskStatus = TASK_STATUS.WAITING;
        }

        // 验证采购工程师及岗位选择
        let flag = false;
        let positionSelected = true;
        this.partList.forEach(element => {
          if(element.supplyEngineerId !== null){
            flag = true;
          }
          // 检查是否每个分配了工程师的零件都选择了岗位
          if(element.supplyEngineerId !== null && !element.selectedPositionId) {
            positionSelected = false;
          }
        });

        if(!flag){
          this.$message.warning("请分配采购工程师");
          return;
        }

        if(!positionSelected){
          this.$message.warning("请为所有分配的零件选择采购工程师岗位");
          return;
        }

        this.dataFormSubmit(params, "任务保存成功");
      },


      dataConfirm() {
        let params = {...this.dataForm};
        params.partList = this.partList;

        if (!params.technicalId) {
          params.settingTaskStatus = TASK_STATUS.WAITING;
        } else {
          params.settingTaskStatus = TASK_STATUS.DISTRIBUTED;
        }

        // 验证采购工程师及岗位选择
        let flag = false;
        this.partList.forEach(element => {
          if(element.supplyEngineerId !== null){
            flag = true;
          }
        });

        if(!flag){
          this.$message.warning("请分配采购工程师");
          return;
        }


        this.dataFormSubmitCon(params, "任务分配成功");
      },
        dataFormSubmitCon(params, message) {
            this.loading = true
            setLoading()
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    if (this.dataForm.id) {
                        editPurchaseTaskCon(params).then((data) => {
                            if (data && data.code === "00") {
                                this.dataForm = data.body
                                this.$message({
                                    message: message,
                                    type: "success",
                                    onClose: () => {
                                        // this.viewData.visible = false;
                                        this.loading = false
                                        this.$emit("refreshDataList");
                                    },
                                });

                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    } else {
                        addPurchaseTask(params).then((data) => {
                            if (data && data.code === "00") {
                                this.dataForm = data.body;
                                this.$message({
                                    message: message,
                                    type: "success",
                                    onClose: () => {
                                        // this.viewData.visible = false;
                                        this.loading = false
                                        this.$emit("refreshDataList");
                                    },
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                }
            });
        },
        dataFormSubmit(params, message) {
            this.loading = true
            setLoading()
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    if (this.dataForm.id) {
                        editPurchaseTask(params).then((data) => {
                            if (data && data.code === "00") {
                                this.dataForm = data.body
                                this.$message({
                                    message: message,
                                    type: "success",
                                    onClose: () => {
                                        this.viewData.visible = false;
                                        this.loading = false
                                        this.$emit("refreshDataList");
                                    },
                                });

                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    } else {
                        addPurchaseTask(params).then((data) => {
                            if (data && data.code === "00") {
                                this.dataForm = data.body;
                                this.$message({
                                    message: message,
                                    type: "success",
                                    onClose: () => {
                                        // this.viewData.visible = false;
                                        this.loading = false
                                        this.$emit("refreshDataList");
                                    },
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                }
            });
        },
        //废弃按钮是否显示
        getPlmTechnicalCountByPT(technicCode) {
            getPlmTechnicalCountByPT({
                technicalCode: this.dataForm.technicalCode,
                technicalStatus: "2",
                receiveStatus: "1",
            }).then(data => {
                if (data && data.code === '00') {
                    if(data.body != null && data.body > 0)
                        this.plmTechCount = data.body
                } else {
                    this.$message.error(data.msg)
                }
            })
        },
        // 废弃
        deleteHandle(id, taskStatus) {
            if(1 == taskStatus) {
                 this.$message({
                    message: "当前采购任务为’已发布‘状态，不可以再做废弃操作！",
                    type: "warning"
                 });
                 return
            }
            this.$confirm(`确定进行废弃操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deletePurchaseTaskFei({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.$emit("refreshDataList");
                                this.viewData.visible = false
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        // 退回定点申请
        backHandle(id) {
            this.$confirm(`确定进行退回操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                backPurchaseTaskFei({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.$emit("refreshDataList");
                                this.viewData.visible = false
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        // 选择定点申请
        selectTech() {
            const _this = this;
            this.$refs.addOrUpdateTech.open();
            this.$refs.addOrUpdateTech.onClosed = (payload) => {
                if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                    mapping(payload.data, _this.dataForm, ["id"]);
                    console.log(
                        payload.data,
                        "payload.data",
                        this.dataForm.carType
                    );
                    _this.dataForm.technicalId = payload.data.defaultPositionId;

                }
            };
        },
        selectAppart() {
            // const _this = this;
            var taskId = this.dataForm.id;
            this.$refs.addOrUpdateAppart.open(
                this.dataForm.technicalId,
                taskId
            );
            this.$refs.addOrUpdateAppart.onClosed = (payload) => {
                if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                    // payload.data === 'OK' 渲染零件列表
                    console.log("OK");
                    if (payload.data === "OK") {
                        this.getTaskApparmentList(taskId);
                    }
                }
            };
        },
        deleteAppart(id) {
            var taskId = this.dataForm.id;
            this.$confirm(`确定进行删除操作?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                deleteTaskApparmentByIds([id]).then((data) => {
                    if (data && data.code === "00") {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                            duration: 1500,
                            onClose: () => {
                                this.getTaskApparmentList(taskId);
                            },
                        });
                    } else {
                        this.$message.error(data.msg);
                    }
                });
            });
        },
        selectResponsor(type) {
            console.log("selectResponsor");
            const _this = this;
            this.$refs.commonUserDialog.open();
            this.$refs.commonUserDialog.onClosed = (payload) => {
                if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                    // this.dataForm.projectManagerId = payload.data.id
                    switch (type) {
                        case 0:
                            _this.dataForm.supplyResponsorId = payload.data.defaultPositionId;
                            _this.dataForm.supplyResponsor =
                                payload.data.realName;
                            break;
                        case 1:
                            _this.dataForm.techResponsorId = payload.data.defaultPositionId;
                            _this.dataForm.techResponsor =
                                payload.data.realName;
                            break;
                        case 2:
                            _this.dataForm.qualityResponsorId = payload.data.defaultPositionId;
                            _this.dataForm.qualityResponsor =
                                payload.data.realName;
                            break;
                        case 3:
                            _this.dataForm.supplyEngineerId = payload.data.defaultPositionId;
                            _this.dataForm.supplyEngineer = payload.data.realName;
                            break;
                        default:
                    }
                }
            };
        },
      // 修改 selectResponsorPop 方法中的岗位处理逻辑
      selectResponsorPop(type) {
        if(this.dataListSelections.length == 0){
          this.$message.warning("请选择数据")
          return
        }
        this.$refs.commonUserDialog.open();
        this.$refs.commonUserDialog.onClosed = (payload) => {
          if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
            for(var i=0; i<this.dataListSelections.length;i++){
              for(var j=0; j<this.partList.length;j++){
                if(this.partList[j].partCode == this.dataListSelections[i].partCode){
                  // 设置采购工程师基本信息
                  this.partList[j].supplyEngineerId = payload.data.defaultPositionId;
                  this.partList[j].supplyEngineer = payload.data.realName;
                  // 添加岗位列表
                  this.$set(this.partList[j], 'positionList', payload.data.positionList || []);
                  // 设置选中的岗位ID逻辑修改
                  if (payload.data.positionList && payload.data.positionList.length > 0) {
                    if (payload.data.positionList.length === 1) {
                      // 如果只有一个岗位，自动选择
                      this.$set(this.partList[j], 'selectedPositionId', payload.data.positionList[0].positionId);
                      this.partList[j].supplyEngineerId = payload.data.positionList[0].positionId;
                    } else {
                      // 如果有多个岗位，不默认选择，让用户手动选择
                      this.$set(this.partList[j], 'selectedPositionId', null);
                      this.partList[j].supplyEngineerId = null;
                    }
                  } else {
                    // 如果没有岗位，保持原逻辑
                    this.$set(this.partList[j], 'selectedPositionId', null);
                  }
                }
              }
            }
          }
        };
      },
      handlePositionChange(row, positionId) {
        // 当岗位选择变化时，更新supplyEngineerId为选中的岗位ID
        if (positionId) {
          row.supplyEngineerId = positionId;
        } else {
          // 如果清空了选择，重置为默认岗位ID
          row.supplyEngineerId = null;
        }
      },
        // 退回理由
        rejectView() {
            this.$refs.taskRejectReason.open();
            this.$refs.taskRejectReason.onClosed = (payload) => {
                if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                    console.log(payload.data)
                    this.dataForm.rejectReason = payload.data
                    this.dataForm.settingTaskStatus = TASK_STATUS.REJECT;
                    this.dataFormSubmit(this.dataForm, "退回成功")
                }
            };
        },
        supplyStatusFormat: function (value) {
            if (!value) {
                return ''
            }
            return getLabelByValue(SUPPLY_STATUS, value)
        },
        getStyle() {
            return 'width: 200px; text-align: right'
        },
        getStyle2() {
            return 'width: 425.5px;'
        },
        techView() {
            this.addOrUpdateVisible = true;
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init({
                    id: this.dataForm.technicalId,
                    projectName: this.dataForm.projectName
                }, "view");
            });
        },
    },
};
</script>
